import { useGetDriversWithOpenReturnsQuery } from '../../services/returnsIntake.endpoints';
import { extractDate, extractTime } from '@/utils';
import { ReturnsIntakeFilters } from '../../models';

interface UseDriversWithOpenReturnsProps {
  filters: ReturnsIntakeFilters;
  page: number;
  pageSize: number;
}

export const useDriversWithOpenReturns = ({
  filters,
  page,
  pageSize,
}: UseDriversWithOpenReturnsProps) => {
  const { data, isLoading } = useGetDriversWithOpenReturnsQuery({
    filters,
    paginated: { page, pageSize },
  });

  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return '-';
    const date: string = extractDate(dateString);
    const time: string = extractTime(dateString);
    if (date === 'N/A' || date === 'Fecha inválida') return '-';
    return `${date} ${time}`;
  };

  const formatDuration = (minutes: number | null) => {
    if (minutes === null) return '-';
    if (minutes < 60) return `${minutes} min`;
    const hours: number = Math.floor(minutes / 60);
    const remainingMinutes: number = minutes % 60;
    if (hours < 24) return `${hours}h ${remainingMinutes}m`;
    const days: number = Math.floor(hours / 24);
    const remainingHours: number = hours % 24;
    return `${days}d ${remainingHours}h`;
  };

  const getStatusColorClass = (minutes: number) => {
    if (minutes >= 720 && minutes < 1440) {
      return 'bg-orange-50 text-orange-600 border border-orange-200 font-bold px-3 py-1 rounded-full';
    } else if (minutes >= 1440) {
      return 'bg-red-50 text-red-600 border border-red-200 font-bold px-3 py-1 rounded-full';
    }
    return 'bg-green-50 text-green-600 border border-green-200 font-bold px-3 py-1 rounded-full';
  };

  return {
    drivers: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: Math.ceil((data?.count || 0) / pageSize),
    isLoading,
    formatDate,
    formatDuration,
    getStatusColorClass,
  };
};
